var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showSpinner)?_c('sc-spinner',{attrs:{"fullscreen":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }